import { aboutFacts, applicationAreas, companyInfo } from '@/mocks/home';
import SectionHeading from './SectionHeading';

export default function About() {
  return (
    <section id="about" className="w-full bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="reveal order-2 lg:order-1">
            <SectionHeading
              align="left"
              eyebrow="About Us"
              title="关于武汉俊鑫岚科技"
              subtitle="我们是一家综合商贸企业，专注为工程、制造与企业客户提供多品类物资供应，用稳定的货源与专业服务解决客户的采购需求。"
            />

            <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed">
              公司立足武汉、服务全国，业务涵盖建筑建材、机械电气、金属材料、电子配件、五金耗材等多个品类，
              同时提供信息咨询与商务代理代办服务。我们以客户需求为中心，致力于成为值得长期信赖的物资供应伙伴。
            </p>

            <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-x-4 gap-y-6 border-t border-background-200 pt-7">
              {aboutFacts.map((fact) => (
                <div key={fact.label}>
                  <div className="font-heading text-lg md:text-xl font-semibold text-primary-700 whitespace-nowrap">
                    {fact.value}
                  </div>
                  <div className="mt-1.5 text-xs md:text-sm text-foreground-500">{fact.label}</div>
                </div>
              ))}
            </div>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="p-5 rounded-lg bg-background-100 border border-background-200">
                <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 mb-3">
                  <i className="ri-stack-line text-xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-950 text-sm">货源可靠</h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                  与上游厂商稳定合作，正规渠道采购，品质有保障。
                </p>
              </div>
              <div className="p-5 rounded-lg bg-background-100 border border-background-200">
                <div className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 text-accent-700 mb-3">
                  <i className="ri-hand-heart-line text-xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-950 text-sm">服务贴心</h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                  专属商务对接，提供选型、报价与代理代办服务。
                </p>
              </div>
            </div>
          </div>

          <div className="reveal order-1 lg:order-2">
            <div className="w-full aspect-[4/3] rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=bright%20modern%20industrial%20warehouse%20with%20organized%20shelves%20of%20building%20materials%2C%20metal%20parts%20and%20packaged%20goods%2C%20clean%20tidy%20logistics%20storage%20space%2C%20soft%20natural%20daylight%2C%20warm%20neutral%20tones%20with%20subtle%20teal%20accents%2C%20professional%20corporate%20photography%2C%20calm%20and%20orderly%20atmosphere&width=1200&height=900&seq=junxinlan-about-02&orientation=squarish&nocache=true"
                alt="武汉俊鑫岚科技 仓储与物资供应场景"
                title="武汉俊鑫岚科技 综合物资供应"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="mt-6 rounded-lg bg-background-100 border border-background-200 p-5 md:p-6">
              <h3 className="font-heading font-semibold text-foreground-950 text-sm mb-4">应用领域</h3>
              <div className="flex flex-wrap gap-2.5">
                {applicationAreas.map((item) => (
                  <span
                    key={item.name}
                    className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full bg-secondary-100 text-secondary-900 text-xs md:text-sm"
                  >
                    <i className={`${item.icon} text-secondary-600`}></i>
                    {item.name}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="reveal mt-10 md:mt-14 rounded-lg bg-primary-950 px-6 md:px-10 py-8 md:py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div>
            <h3 className="font-heading text-xl md:text-2xl font-semibold text-background-50">
              {companyInfo.slogan}
            </h3>
            <p className="mt-2 text-sm text-background-300">
              有采购需求？欢迎随时与我们沟通，为您提供报价与选型建议。
            </p>
          </div>
          <a
            href="#contact"
            className="shrink-0 px-7 py-3.5 rounded-md bg-accent-500 text-accent-950 font-medium text-sm hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            立即获取报价
          </a>
        </div>
      </div>
    </section>
  );
}